import { useState, useEffect } from "react";
import {
  RelatorioFiltrar,
} from "src/services/Relatorio.Service";
import { showToast } from "src/componentes";
import { RelatorioDto } from "./RelatorioSistema.Dto";
import { MapearErrosServidor } from "src/hook/Functions";

const RelatorioSistemaCode = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<RelatorioDto[]>([]);

  const fetchRelatorios = async () => {
    setLoading(true);
    try {
      const response = await RelatorioFiltrar({});
      if (response.data.success) {
        setData(response.data.data);
      } else {
        MapearErrosServidor(response.data.notifications, showToast);
      }
    } catch (error) {
      console.error(error);
      showToast({
        message: "Ocorreu erro ao buscar dados",
        title: "Erro",
        variant: "Danger",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRelatorios();
  }, []);

  return {
    loading,
    data,
    fetchRelatorios,
  };
};

export default RelatorioSistemaCode;
